module.exports = __webpack_public_path__ + "static/21-09-28_11-49-54_3BA8-23f678487ebb2f3d5793160f02463534.jpg";